export default {"src":"/_next/static/media/enerflo-culture-icon.62b91040.svg","height":67,"width":68};